import React          from 'react';
import classNames     from 'classnames';
import * as PropTypes from 'prop-types';

function Alert({
  type,
  message,
  hide,
}) {
  const [state, setState] = React.useState(null);

  const hideMessage = () => {
    if (!isSSR()) {
      setState('fadeOut');
      setTimeout(() => {
        setState('hide');
        setTimeout(hide, 500);
      }, 500);
    }
  };

  React.useEffect(() => {
    let timer;
    if (!isSSR()) {
      setTimeout(() => {
        setState('fade');
        setTimeout(() => {
          setState('fadeIn');
          timer = setTimeout(hideMessage, 5000);
        }, 500);
      }, 500);
    }
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div
      className={classNames('alert', type, state)}
    >
      <div>{message}</div>
      <span
        className={'ic-close'}
        onClick={hideMessage}
      />
    </div>
  );
};

Alert.propTypes = {
  type:    PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  hide:    PropTypes.func.isRequired,
};
export default Alert;